import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PageHeadingSection from '../../../common/pageheading/PageHeadingSection';
import Breadcrumbs from '../../../common/BreadCrum/BreadCrum';
import SectionTab from '../../../common/sectiontab/SectionTab';
import SplitEqualityForm from './SplitEqualityForm';
import IndividualUnitForm from './IndividualUnitForm';
import apiServices from '../../../../services/apiService';

const MaintenanceForm = () => {
    const [units, setUnits] = useState([]);
    const { user: authUser } = useSelector((state) => state.auth);
    const loggedInUserId = authUser?.id;
    const [isLoading, setIsLoading] = useState(false);
    const [siteAdminData, setSiteAdminData] = useState({
        siteId: "",
        wingId: "",
        floorId: "",
        unitId: ""
    });

    const fetchUserDetails = async () => {
        if (!loggedInUserId) return;
        setIsLoading(true);
        try {
            const res = await apiServices({
                method: "GET",
                url: `/CommUserDetails/getUserDetailsById/${loggedInUserId}`
            });

            const raw = res?.data?.Commuserdetailsdata?.[0];
            if (raw) {
                setSiteAdminData(prev => ({
                    ...prev,
                    siteId: raw.siteId || "",
                    wingId: raw.WingId || "",
                    floorId: raw.FloorId || "",
                    unitId: raw.UnitId || ""
                }));
            }
        } catch (error) {
            console.error("Error fetching user details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUserDetails();
    }, [loggedInUserId]);

    const fetchUnits = async () => {
        setIsLoading(true)
        if (!siteAdminData?.siteId) {
            return
        }
        try {
            const res = await apiServices({
                method: "GET",
                url: `/unit/members/${siteAdminData?.siteId}/4`,
                useNodeApi: true
            });
            if (res?.success) {
                let apiData = res.data.data || []; // Safely get the nested array
                setUnits(apiData.map(u => ({
                    label: u.FirstName ? `${u.UnitName} - ${u.UnitNumber} (${u.FirstName} ${u.LastName})` : `${u.UnitName} - ${u.UnitNumber}`,
                    value: u.UnitId,
                    unitAdminId: u.UserId // map the member ID
                })));
                setIsLoading(false)
            }
        } catch (err) {
            console.error("Failed to fetch units");
            setIsLoading(false)
        }
    };

    useEffect(() => {
        if (siteAdminData?.siteId) {
            fetchUnits();
        }
    }, [siteAdminData?.siteId]);

    const tabs = useMemo(() => [
        { key: "split", label: "Split Equality", component: () => <SplitEqualityForm units={units} siteAdminData={siteAdminData} /> },
        { key: "individual", label: "Individual Unit", component: () => <IndividualUnitForm units={units} siteAdminData={siteAdminData} /> }
    ], [units, siteAdminData]);

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto pt-4 scrollbar-hide">
            <Breadcrumbs />

            <PageHeadingSection
                Navbar={true}
                mainHeading="Add New Maintenance"
                subHeading="Generate maintenance invoices"
            />

            <SectionTab
                tabs={tabs}
                defaultTab="split"
            />
        </div>
    );
};

export default MaintenanceForm;
